import { ChangeEvent, useState } from 'react';
import { Box } from '@nimbus-ds/components';
import { ExclamationTriangleIcon } from '@nimbus-ds/icons';
import { EmptyMessage, InteractiveList } from '@nimbus-ds/patterns';
import { noop } from 'lodash';
import { ProvinceDto } from '@tiendanube/common';
import GenericSelectionModalHeader from 'domains/Shipping/DeliveryMethods/pages/components/SelectionModals/shared/GenericSelectionModal/GenericSelectionModalHeader';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import ProvincesListSkeleton from './Skeleton';

interface ProvincesListProps {
  readonly provinces: ProvinceDto[];
  readonly filteredProvinces: ProvinceDto[];
  readonly handleSelectProvince: (selectedOption: string) => void;
  readonly handleSetFilter: (filter: ProvinceDto[]) => void;
}

function ProvincesList({
  provinces,
  filteredProvinces,
  handleSelectProvince,
  handleSetFilter,
}: Readonly<ProvincesListProps>) {
  const t = useTranslationShipping();
  const [searchValue, setSearchValue] = useState('');

  const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    const filtered = provinces
      ? provinces.filter(
          ({ name }) => name.search(new RegExp(e.target.value, 'i')) >= 0,
        )
      : [];

    handleSetFilter(filtered);
  };

  return (
    <>
      <GenericSelectionModalHeader
        title={t('deliveryMethods.customShipping.selectProvinceModal.title')}
        description={t(
          'deliveryMethods.customShipping.selectProvinceModal.description',
        )}
        totalItems={provinces.length}
        selectedCount={0}
        searchTerm={searchValue}
        searchPlaceholder={t(
          'deliveryMethods.customShipping.selectProvinceModal.search',
        )}
        counterText=""
        minItemsForSearch={0}
        onSearchChange={handleChangeSearch}
        onClearSelection={noop}
      />

      {!!searchValue && filteredProvinces.length === 0 && (
        <EmptyMessage
          title={t(
            'deliveryMethods.customShipping.selectProvinceModal.titleSearch',
          )}
          text={t(
            'deliveryMethods.customShipping.selectProvinceModal.messageSearch',
          )}
          icon={<ExclamationTriangleIcon size="large" />}
        />
      )}
      <Box paddingTop="4">
        <InteractiveList>
          {filteredProvinces.map((province) => (
            <InteractiveList.ButtonItem
              key={province.code}
              title={province.name}
              iconButton={{
                onClick: () => handleSelectProvince(province.code),
              }}
            />
          ))}
        </InteractiveList>
      </Box>
    </>
  );
}

ProvincesList.Skeleton = ProvincesListSkeleton;
export default ProvincesList;
